import React, {Component} from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Button
} from 'reactstrap';
import {Link} from 'react-router-dom';
import Tabs from '../../../components/Tabs';
import EmployeeGroup from './tabs/EmployeeGroup';

class View extends Component {

  constructor(props) {
    super(props);

    this.state = {
      activeTab: "0"
    };

    this.tabs = [
      this.getEmployeeGroupTab()
    ];
  }

  getEmployeeGroupTab() {
    return {
      id: "employee",
      name: "Employee",
      body: (<EmployeeGroup id={this.props.match.params.id} />)
    };
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Card>
          <CardHeader>
            <Link to={'/employee-groups/list'}><Button size="sm">Back</Button></Link>
          </CardHeader>
          <CardBody>
            <Row>
              <Col xs="12">
                <Tabs tabs={this.tabs} />
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default View;


// WEBPACK FOOTER //
// ./src/views/Employee/EmployeeGroupView/View.js